import React, { useEffect, useState, useRef } from "react";
import "./dashboard.scss";
import Table from "react-bootstrap/Table";
import { toast } from "react-toastify";
import { Pagination } from "react-bootstrap";
import axios from "axios";
import { API_URL } from "utils/ApiUrl";
import Loader from "utils/loader";
import useFetchAdminStats from "../../hooks/useFetchAdminStats";
import copy from 'copy-to-clipboard';
import useWeb3 from "hooks/useWeb3";

const Dashboard = ({ search, setSearch }) => {

  const web3 = useWeb3();
  const debounceTimeout = useRef(null);

  console.log(search, setSearch, 'dasshbord search bar ')


  const adminDashboardStats = useFetchAdminStats();
  console.log(adminDashboardStats);
  const [transactions, setUsers] = useState([]);
  const [offset, setOffset] = useState(1); // page number
  const [limit] = useState(10); // items per page
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [show1, setShow1] = useState(false);

  const MIN = 0;
  const MAX = 100;
  // Fetch transactions from API
  // const fetchTransactions = async () => {
  //   setLoading(true);
  //   const accessToken = localStorage.getItem("token");
  //   console.log("accessToken", accessToken);


  //   // Determine whether the search is a wallet address or a name
  //   const isWalletAddress = web3.utils.isAddress(search);
  //   // setLoading(true);

  //   let queryParams = isWalletAddress
  //     ? { ...(search && { walletAddress: search }), offset, limit } // Only add walletAddress if search is not empty
  //     : { ...(search && { name: search }), offset, limit }; // Only add name if search is not empty
  //   // Otherwise, add name
  //   try {
  //     const response = await axios.get(
  //       `${API_URL}/transactions/all-transactions`,
  //       // 'http://192.168.30.183:8088/transactions/all-transactions?limit=200&offset=1',

  //       // 'http://192.168.30.183:8088/transactions/all-transactions?limit=200&offset=1',


  //       // 'http://192.168.30.183:8088/transactions/all-transactions?',
  //       {
  //         params: { offset, limit, queryParams },
  //         headers: {
  //           Authorization: `Bearer ${accessToken}`,
  //           "content-type": "application/json",
  //         },
  //       }
  //     );
  //     console.log('response ', response.data)

  //     const data = response.data.data;
  //     // console.log("Transaction api response: ", response);
  //     console.log("Transactions activity data : ", data);
  //     setUsers(data.transactions);
  //     setTotalItems(data.count); // Total number of items
  //     setTotalPages(data.pages); // Total pages from API
  //   } catch (error) {
  //     console.error("Error fetching transactions:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // useEffect(() => {
  //   fetchTransactions();
  // }, [offset, limit, search]);
  const fetchTransactions = async () => {
    setLoading(true);
    const accessToken = localStorage.getItem("token");
    console.log("accessToken", accessToken);

    // Ensure the search term is valid and determine whether it's a wallet address or name
    const isWalletAddress = web3.utils.isAddress(search);

    // Create queryParams based on whether the search is a wallet address or a name
    let queryParams = {};

    if (search && search.trim() !== "") {
      queryParams = isWalletAddress
        ? { walletAddress: search }  // Add walletAddress if search is a valid address
        : { name: search };          // Otherwise, add name
    }

    // Always add offset and limit to queryParams
    queryParams = { ...queryParams, offset: '1', limit };

    try {
      const response = await axios.get(
        `${API_URL}/transactions/all-transactions`,
        {
          params: queryParams, // Pass the dynamically generated queryParams
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "content-type": "application/json",
          },
        }
      );
      console.log("response", response.data);
      const data = response.data.data;
      console.log("Transactions activity data: ", data);
      setUsers(data.transactions); // Assuming you want to set the transactions
      setTotalItems(data.count); // Total number of items
      setTotalPages(data.pages); // Total pages from API
    } catch (error) {
      console.error("Error fetching transactions:", error);
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   fetchTransactions(); // Trigger API call when offset, limit, or search changes
  // }, [offset, limit, search]);


  useEffect(() => {
    if (search) {
      // Clear the previous timeout if the user continues typing
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }

      // Set a new timeout to trigger the fetch after 500ms
      debounceTimeout.current = setTimeout(() => {
        fetchTransactions(search);
      }, 700); // Adjust delay time (in milliseconds) as needed
    } else if (search === "") {
      // If search is empty, fetch all projects
      fetchTransactions();
    }

    // Cleanup function to clear timeout
    return () => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
    };
  }, [search, offset, limit]);


  // Pagination logic
  const handlePageChange = (page) => {
    setOffset(page);
  };

  const [copiedIndex, setCopiedIndex] = useState(null); // Store the index of the copied item
  const handleCopyToClipboard = (index, walletAddress) => {
    copy(walletAddress); // Copy the wallet address to the clipboard
    setCopiedIndex(index); // Set the index of the copied item

    // Remove the copied message after 2 seconds
    setTimeout(() => {
      setCopiedIndex(null); // Reset the copied index to null
    }, 2000);
  };

  const changeDateFormat = (createdAt) => {
    // console.log("🚀 ~ changeDateFormat ~ createdAt:", createdAt);

    // Convert createdAt to a Date object
    const originalDate = new Date(createdAt);

    // Format the date and time for Pakistan Standard Time
    const formattedDate = originalDate.toLocaleString('en-US', {
      timeZone: 'Asia/Karachi', // Set the time zone to Pakistan
      month: 'short',          // Short month name (e.g., Dec)
      day: 'numeric',          // Numeric day (e.g., 24)
      year: 'numeric',         // Full year (e.g., 2024)
      hour: 'numeric',         // Hour
      minute: 'numeric',       // Minutes
      second: 'numeric',       // Seconds
      hour12: true             // Use 12-hour clock (AM/PM)
    });

    // Return the formatted date and time
    return formattedDate;
  };

  const revenueInBnb = (() => {
    const v = adminDashboardStats?.revenueIncome;
    if (v === undefined || v === null || v === "") return 0;

    const s = String(v).trim();
    // If backend already returns a decimal (e.g. "0.0001"), treat it as BNB.
    if (s.includes(".")) {
      const n = Number(s);
      return Number.isFinite(n) ? n : 0;
    }

    // Otherwise assume it's wei (integer string) and convert.
    try {
      return Number(web3.utils.fromWei(s, "ether"));
    } catch (e) {
      return 0;
    }
  })();



  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="content">
            <section className="dashboard-section">
              <div className="mainparent">
                <div className="upperside">
                  <div className="totalearning">
                    <div className="innerdiv">
                      <div className="shoppingbags">
                        <img alt="bag" src="\assets\dashboard\users.svg" />
                      </div>

                      <div>
                        <p>Total Users</p>
                        <h6>{adminDashboardStats?.totalUsers || "N/A"}</h6>
                      </div>
                    </div>
                    {/* <h2>+2.3% since last month</h2> */}
                  </div>
                  <div className="totalearning">
                    <div className="innerdiv">
                      <div className="shoppingbags">
                        <img alt="bag" src="\assets\dashboard\Revenue.svg" />
                      </div>

                      <div>
                        <p>Total Revenue</p>
                        <h6>{revenueInBnb.toFixed(6)}</h6>
                      </div>
                    </div>
                    {/* <h3>-0.6% since last month</h3> */}
                  </div>
                  <div className="totalearning">
                    <div className="innerdiv">
                      <div className="shoppingbags">
                        <img alt="bag" src="\assets\dashboard\Sold.svg" />
                      </div>

                      <div>
                        <p>Fractions Sold</p>
                        <h6>{adminDashboardStats?.nftCount}</h6>
                      </div>
                    </div>
                    {/* <h2>+1.2% Since last month</h2> */}
                  </div>
                  <div className="totalearning">
                    <div className="innerdiv">
                      <div className="shoppingbags">
                        <img alt="bag" src="\assets\dashboard\Rental.svg" />
                      </div>

                      <div>
                        <p>Total Rental Revenue</p>
                        <h6>${adminDashboardStats?.rentalIncome?.toFixed(6)}</h6>
                      </div>
                    </div>
                    {/* <h2>+2.3% since last month</h2> */}
                  </div>
                  <div className="totalearning">
                    <div className="innerdiv">
                      <div className="shoppingbags">
                        <img alt="bag" src="\assets\dashboard\Commission.svg" />
                      </div>

                      <div>
                        <p>Rental Commission</p>
                        <h6>${adminDashboardStats?.totalCommission?.toFixed(6)}</h6>
                      </div>
                    </div>
                    {/* <h3>-0.6% since last month</h3> */}
                  </div>
                  <div className="totalearning">
                    <div className="innerdiv">
                      <div className="shoppingbags">
                        <img alt="bag" src="\assets\dashboard\Referrals.svg" />
                      </div>

                      <div>
                        <p>Total Referrals</p>
                        <h6>{adminDashboardStats?.totalrefferals}</h6>
                      </div>
                    </div>
                    {/* <h2>+1.2% Since last month</h2> */}
                  </div>
                  {/* <div className='flex_div1 d-none'>
                <img src='\assets\dashboard\rank.svg' alt='img' />
                <img src='\product\whiteshade.svg' alt='imgggg' className='imgposss' />
                <div className='innerwrapp'>
                  <div className='wrapsmall'>
                    <p>Current Level</p>
                    <h1>5</h1>
                  </div>
                  <div className='wrapsmall'>
                    <p>Current Rank</p>
                    <h1>3</h1>
                  </div>
                  <div className='wrapsmall'>
                    <p>Points Earned</p>
                    <h1>215</h1>
                  </div>
                </div>

              </div> */}
                </div>
                <div className="wraper">
                  <div className="innergraph">
                    <h1 className="nnhgft">Transaction Activity</h1>
                    {/* <button className='seebutton'>See All</button> */}
                  </div>
                  <div className="leftside">
                    <div className="Products">
                      <div className="respheight">
                        <div className="tablemains">
                          <Table responsive>
                            <thead>
                              <tr>
                                <th>
                                  <p className="namesvg">
                                    User
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="8"
                                      height="11"
                                      viewBox="0 0 8 11"
                                      fill="none"
                                    >
                                      <path
                                        d="M7.44734 6.21436H4.26892H1.40681C0.91704 6.21436 0.672154 6.86485 1.01908 7.24618L3.66181 10.151C4.08525 10.6164 4.774 10.6164 5.19745 10.151L6.2025 9.04626L7.84017 7.24618C8.18199 6.86485 7.93711 6.21436 7.44734 6.21436Z"
                                        fill="#D3D3D3"
                                      />
                                      <path
                                        d="M7.44734 4.78564H4.26892H1.40681C0.91704 4.78564 0.672154 4.13515 1.01908 3.75382L3.66181 0.849019C4.08525 0.383578 4.774 0.383578 5.19745 0.849019L6.2025 1.95374L7.84017 3.75382C8.18199 4.13515 7.93711 4.78564 7.44734 4.78564Z"
                                        fill="black"
                                      />
                                    </svg>
                                  </p>
                                </th>
                                <th>
                                  <p className="namesvg">
                                    Email
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="8"
                                      height="11"
                                      viewBox="0 0 8 11"
                                      fill="none"
                                    >
                                      <path
                                        d="M7.44734 6.21436H4.26892H1.40681C0.91704 6.21436 0.672154 6.86485 1.01908 7.24618L3.66181 10.151C4.08525 10.6164 4.774 10.6164 5.19745 10.151L6.2025 9.04626L7.84017 7.24618C8.18199 6.86485 7.93711 6.21436 7.44734 6.21436Z"
                                        fill="#D3D3D3"
                                      />
                                      <path
                                        d="M7.44734 4.78564H4.26892H1.40681C0.91704 4.78564 0.672154 4.13515 1.01908 3.75382L3.66181 0.849019C4.08525 0.383578 4.774 0.383578 5.19745 0.849019L6.2025 1.95374L7.84017 3.75382C8.18199 4.13515 7.93711 4.78564 7.44734 4.78564Z"
                                        fill="black"
                                      />
                                    </svg>
                                  </p>
                                </th>
                                <th>
                                  <p className="namesvg">Wallet Address</p>
                                </th>
                                <th>
                                  <p className="namesvg">
                                    Date
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="8"
                                      height="11"
                                      viewBox="0 0 8 11"
                                      fill="none"
                                    >
                                      <path
                                        d="M7.44734 6.21436H4.26892H1.40681C0.91704 6.21436 0.672154 6.86485 1.01908 7.24618L3.66181 10.151C4.08525 10.6164 4.774 10.6164 5.19745 10.151L6.2025 9.04626L7.84017 7.24618C8.18199 6.86485 7.93711 6.21436 7.44734 6.21436Z"
                                        fill="#D3D3D3"
                                      />
                                      <path
                                        d="M7.44734 4.78564H4.26892H1.40681C0.91704 4.78564 0.672154 4.13515 1.01908 3.75382L3.66181 0.849019C4.08525 0.383578 4.774 0.383578 5.19745 0.849019L6.2025 1.95374L7.84017 3.75382C8.18199 4.13515 7.93711 4.78564 7.44734 4.78564Z"
                                        fill="black"
                                      />
                                    </svg>
                                  </p>
                                </th>
                                <th>
                                  <p className="namesvg">
                                    NFT ID
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="8"
                                      height="11"
                                      viewBox="0 0 8 11"
                                      fill="none"
                                    >
                                      <path
                                        d="M7.44734 6.21436H4.26892H1.40681C0.91704 6.21436 0.672154 6.86485 1.01908 7.24618L3.66181 10.151C4.08525 10.6164 4.774 10.6164 5.19745 10.151L6.2025 9.04626L7.84017 7.24618C8.18199 6.86485 7.93711 6.21436 7.44734 6.21436Z"
                                        fill="#D3D3D3"
                                      />
                                      <path
                                        d="M7.44734 4.78564H4.26892H1.40681C0.91704 4.78564 0.672154 4.13515 1.01908 3.75382L3.66181 0.849019C4.08525 0.383578 4.774 0.383578 5.19745 0.849019L6.2025 1.95374L7.84017 3.75382C8.18199 4.13515 7.93711 4.78564 7.44734 4.78564Z"
                                        fill="black"
                                      />
                                    </svg>
                                  </p>
                                </th>
                                <th>
                                  <p className="namesvg">
                                    Rent
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="8"
                                      height="11"
                                      viewBox="0 0 8 11"
                                      fill="none"
                                    >
                                      <path
                                        d="M7.44734 6.21436H4.26892H1.40681C0.91704 6.21436 0.672154 6.86485 1.01908 7.24618L3.66181 10.151C4.08525 10.6164 4.774 10.6164 5.19745 10.151L6.2025 9.04626L7.84017 7.24618C8.18199 6.86485 7.93711 6.21436 7.44734 6.21436Z"
                                        fill="#D3D3D3"
                                      />
                                      <path
                                        d="M7.44734 4.78564H4.26892H1.40681C0.91704 4.78564 0.672154 4.13515 1.01908 3.75382L3.66181 0.849019C4.08525 0.383578 4.774 0.383578 5.19745 0.849019L6.2025 1.95374L7.84017 3.75382C8.18199 4.13515 7.93711 4.78564 7.44734 4.78564Z"
                                        fill="black"
                                      />
                                    </svg>
                                  </p>
                                </th>
                              </tr>
                            </thead>

                            <tbody>
                              {transactions.map((transaction, index) => (
                                <tr key={index}>
                                  <td>
                                    <p className="pargraphapple">
                                      {/* {transaction.userId.name || "N/A"}{" "} */}
                                      {/* Fallback to "N/A" if name is missing */}
                                      {transaction?.userId?.name ||
                                        transaction?.userId?.email?.split("@")[0] ||
                                        "N/A"}

                                    </p>
                                  </td>
                                  <td>
                                    <p className="pargraphapple">
                                      {transaction.userId.email || "N/A"}{" "}
                                      {/* Fallback to "N/A" if email is missing */}
                                    </p>
                                  </td>
                                  <td>
                                    <p className="pargraphapple">
                                      <span className="">
                                        {transaction.walletAddress
                                          ? `${transaction.walletAddress.slice(0, 5)}...${transaction.walletAddress.slice(-5)}`
                                          : "N/A"}
                                      </span>
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="18"
                                        height="18"
                                        viewBox="0 0 18 18"
                                        fill="none"
                                        className="pl-3 mx-3"
                                        onClick={() => handleCopyToClipboard(index, transaction?.walletAddress)} // Pass walletAddress directly
                                        style={{ cursor: "pointer" }}
                                      >
                                        <path
                                          opacity="0.2"
                                          d="M15.1875 2.8125V11.8125H11.8125V6.1875H6.1875V2.8125H15.1875Z"
                                          fill="#10312B"
                                        />
                                        <path
                                          d="M15.1875 2.25H6.1875C6.03832 2.25 5.89524 2.30926 5.78975 2.41475C5.68426 2.52024 5.625 2.66332 5.625 2.8125V5.625H2.8125C2.66332 5.625 2.52024 5.68426 2.41475 5.78975C2.30926 5.89524 2.25 6.03832 2.25 6.1875V15.1875C2.25 15.3367 2.30926 15.4798 2.41475 15.5852C2.52024 15.6907 2.66332 15.75 2.8125 15.75H11.8125C11.9617 15.75 12.1048 15.6907 12.2102 15.5852C12.3157 15.4798 12.375 15.3367 12.375 15.1875V12.375H15.1875C15.3367 12.375 15.4798 12.3157 15.5852 12.2102C15.6907 12.1048 15.75 11.9617 15.75 11.8125V2.8125C15.75 2.66332 15.6907 2.52024 15.5852 2.41475C15.4798 2.30926 15.3367 2.25 15.1875 2.25ZM11.25 14.625H3.375V6.75H11.25V14.625ZM14.625 11.25H12.375V6.1875C12.375 6.03832 12.3157 5.89524 12.2102 5.78975C12.1048 5.68426 11.9617 5.625 11.8125 5.625H6.75V3.375H14.625V11.25Z"
                                          fill="#10312B"
                                        />
                                      </svg>
                                      {/* {copiedIndex === index ? 'Copied!' : 'Copy Address'} */}
                                    </p>
                                    {/* Conditionally show "Copied!" message below the wallet address that was copied */}
                                    {copiedIndex === index && (
                                      <div className="copied-message" >
                                        <span>Copied!</span> {/* Show "Copied!" message only for the clicked index */}
                                      </div>
                                    )}
                                  </td>
                                  <td>
                                    <p className="pargraphapple">






                                      {
                                        // console.log("Transaction CreatedAt:", transaction?.userId?.createdAt),
                                        transaction?.userId?.createdAt
                                          ? changeDateFormat(transaction.userId.createdAt)
                                          : "N/F"
                                      }






                                      {/* Fallback to "N/A" if createdAt is missing */}
                                    </p>
                                  </td>
                                  {/*  */}
                                  <td>
                                    {/* <p className="pargraphapple">
                                      {transaction.tokenIdStart || "N/A"}{" "}
                                     </p> */}
                                    {/* <p className="pargraphapple">
                                      #{transaction.tokenIdStart || "N/A"}  
                                      {" - "}
                                      #{transaction.tokenIdEnd || "N/A"}  
                                    </p> */}
                                    <p className="pargraphapple">
                                      {transaction.tokenIdStart === transaction.tokenIdEnd
                                        ? `#${transaction.tokenIdStart || "N/A"}`  // If the token IDs are the same, display only tokenIdStart
                                        : `#${transaction.tokenIdStart || "N/A"} - #${transaction.tokenIdEnd || "N/A"}`}
                                      {/* // Otherwise, display both tokenIdStart and tokenIdEnd */}
                                    </p>

                                  </td>
                                  <td>
                                    <p className="pargraphapple">
                                      $
                                      {(transaction.rentPerNft / 12).toFixed(6) || "N/A"}{" "}
                                      {/* ${adminDashboardStats?.revenueIncome?.toFixed(6)} */}





                                      {/* Fallback to "N/A" if mintAmount is missing */}
                                    </p>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                          <div className="paginationdiv">
                            <p>
                              {totalItems === 0
                                ? "SHOWING 0 OF 0"
                                : `SHOWING ${(offset - 1) * limit + 1}-${Math.min(
                                  offset * limit,
                                  totalItems
                                )} OF ${totalItems}`}
                            </p>
                            <div className="numberbagidiv">
                              <Pagination>
                                <Pagination.Prev
                                  onClick={() => {
                                    if (totalItems > 0)
                                      handlePageChange(Math.max(1, offset - 1));
                                  }}
                                  disabled={offset === 1 || totalItems === 0}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    className="rightarow"
                                  >
                                    <path
                                      opacity="0.2"
                                      d="M5 6.5L8 9.5V3.5L5 6.5Z"
                                      fill="#858585"
                                    />
                                    <path
                                      d="M1.64625 6.85366L4.64625 9.85366C4.74007 9.94748 4.86732 10.0002 5 10.0002C5.13268 10.0002 5.25993 9.94748 5.35375 9.85366C5.44757 9.75984 5.50028 9.63259 5.50028 9.49991C5.50028 9.36722 5.44757 9.23998 5.35375 9.14616L2.70687 6.49991L5.35375 3.85366C5.40021 3.8072 5.43705 3.75205 5.4622 3.69135C5.48734 3.63066 5.50028 3.5656 5.50028 3.49991C5.50028 3.43421 5.48734 3.36915 5.4622 3.30846C5.43705 3.24776 5.40021 3.19261 5.35375 3.14616C5.25993 3.05234 5.13268 2.99963 5 2.99963C4.9343 2.99963 4.86925 3.01257 4.80855 3.03771C4.74786 3.06285 4.69271 3.0997 4.64625 3.14616L1.64625 6.14616C1.59976 6.19259 1.56288 6.24774 1.53772 6.30844C1.51256 6.36913 1.49961 6.4342 1.49961 6.49991C1.49961 6.56561 1.51256 6.63068 1.53772 6.69138C1.56288 6.75207 1.59976 6.80722 1.64625 6.85366ZM4.64625 6.85366L7.64625 9.85366C7.71618 9.92366 7.8053 9.97134 7.90235 9.99067C7.99939 10.01 8.09998 10.0001 8.1914 9.96222C8.28281 9.92434 8.36092 9.86019 8.41586 9.7779C8.4708 9.6956 8.50008 9.59885 8.5 9.49991V7.02303C9.8658 7.14928 11.1353 7.78068 12.0601 8.79366C12.9849 9.80665 13.4984 11.1283 13.5 12.4999C13.5 12.6325 13.5527 12.7597 13.6464 12.8535C13.7402 12.9472 13.8674 12.9999 14 12.9999C14.1326 12.9999 14.2598 12.9472 14.3536 12.8535C14.4473 12.7597 14.5 12.6325 14.5 12.4999C14.4979 10.8631 13.8793 9.28714 12.7674 8.08601C11.6554 6.88488 10.1318 6.14674 8.5 6.01866V3.49991C8.50008 3.40096 8.4708 3.30421 8.41586 3.22191C8.36092 3.13962 8.28281 3.07547 8.1914 3.03759C8.09998 2.99972 7.99939 2.98982 7.90235 3.00914C7.8053 3.02847 7.71618 3.07615 7.64625 3.14616L4.64625 6.14616C4.59976 6.19259 4.56288 6.24774 4.53772 6.30844C4.51256 6.36913 4.49961 6.4342 4.49961 6.49991C4.49961 6.56561 4.51256 6.63068 4.53772 6.69138C4.56288 6.75207 4.59976 6.80722 4.64625 6.85366ZM5.70875 6.49991L7.5 4.70678V8.29303L5.70875 6.49991Z"
                                      fill="#858585"
                                    />
                                  </svg>
                                </Pagination.Prev>
                                {/* Pagination Items */}
                                {totalPages <= 5 ? (
                                  // Show all pages if totalPages <= 5
                                  [...Array(totalPages)].map((_, i) => (
                                    <Pagination.Item
                                      key={i}
                                      active={i + 1 === offset}
                                      onClick={() => handlePageChange(i + 1)}
                                    >
                                      {i + 1}
                                    </Pagination.Item>
                                  ))
                                ) : (
                                  // Handle ellipsis for large number of pages
                                  <>
                                    <Pagination.Item
                                      active={offset === 1}
                                      onClick={() => handlePageChange(1)}
                                    >
                                      1
                                    </Pagination.Item>
                                    {offset > 3 && (
                                      <Pagination.Ellipsis disabled />
                                    )}
                                    {offset === 1 || offset === totalPages
                                      ? [...Array(3)].map((_, i) => {
                                        const page =
                                          offset === 1
                                            ? i + 1
                                            : totalPages - 3 + i + 1;
                                        return (
                                          <Pagination.Item
                                            key={page}
                                            active={page === offset}
                                            onClick={() =>
                                              handlePageChange(page)
                                            }
                                          >
                                            {page}
                                          </Pagination.Item>
                                        );
                                      })
                                      : [...Array(3)].map((_, i) => {
                                        const page = offset - 1 + i;
                                        return (
                                          <Pagination.Item
                                            key={page}
                                            active={page === offset}
                                            onClick={() =>
                                              handlePageChange(page)
                                            }
                                          >
                                            {page}
                                          </Pagination.Item>
                                        );
                                      })}
                                    {offset < totalPages - 2 && (
                                      <Pagination.Ellipsis disabled />
                                    )}
                                    <Pagination.Item
                                      active={offset === totalPages}
                                      onClick={() => handlePageChange(totalPages)}
                                    >
                                      {totalPages}
                                    </Pagination.Item>
                                  </>
                                )}
                                <Pagination.Next
                                  onClick={() => {
                                    if (totalItems > 0)
                                      handlePageChange(
                                        Math.min(totalPages, offset + 1)
                                      );
                                  }}
                                  disabled={
                                    offset === totalPages || totalItems === 0
                                  }
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    className="leftti"
                                  >
                                    <path
                                      opacity="0.2"
                                      d="M11 6.5L8 9.5V3.5L11 6.5Z"
                                      fill="#858585"
                                    />
                                    <path
                                      d="M14.3538 6.85366L11.3538 9.85366C11.2599 9.94748 11.1327 10.0002 11 10.0002C10.8673 10.0002 10.7401 9.94748 10.6462 9.85366C10.5524 9.75984 10.4997 9.63259 10.4997 9.49991C10.4997 9.36722 10.5524 9.23998 10.6462 9.14616L13.2931 6.49991L10.6462 3.85366C10.5998 3.8072 10.5629 3.75205 10.5378 3.69135C10.5127 3.63066 10.4997 3.5656 10.4997 3.49991C10.4997 3.43421 10.5127 3.36915 10.5378 3.30846C10.5629 3.24776 10.5998 3.19261 10.6462 3.14616C10.7401 3.05234 10.8673 2.99963 11 2.99963C11.0657 2.99963 11.1308 3.01257 11.1914 3.03771C11.2521 3.06285 11.3073 3.0997 11.3538 3.14616L14.3538 6.14616C14.4002 6.19259 14.4371 6.24774 14.4623 6.30844C14.4874 6.36913 14.5004 6.4342 14.5004 6.49991C14.5004 6.56561 14.4874 6.63068 14.4623 6.69138C14.4371 6.75207 14.4002 6.80722 14.3538 6.85366ZM11.3538 6.85366L8.35375 9.85366C8.28382 9.92366 8.1947 9.97134 8.09765 9.99067C8.00061 10.01 7.90002 10.0001 7.8086 9.96222C7.71719 9.92434 7.63908 9.86019 7.58414 9.7779C7.5292 9.6956 7.49992 9.59885 7.5 9.49991V7.02303C6.1342 7.14928 4.86467 7.78068 3.93989 8.79366C3.01511 9.80665 2.50165 11.1283 2.5 12.4999C2.5 12.6325 2.44732 12.7597 2.35355 12.8535C2.25979 12.9472 2.13261 12.9999 2 12.9999C1.86739 12.9999 1.74021 12.9472 1.64645 12.8535C1.55268 12.7597 1.5 12.6325 1.5 12.4999C1.50205 10.8631 2.12068 9.28714 3.23262 8.08601C4.34457 6.88488 5.86821 6.14674 7.5 6.01866V3.49991C7.49992 3.40096 7.5292 3.30421 7.58414 3.22191C7.63908 3.13962 7.71719 3.07547 7.8086 3.03759C7.90002 2.99972 8.00061 2.98982 8.09765 3.00914C8.1947 3.02847 8.28382 3.07615 8.35375 3.14616L11.3538 6.14616C11.4002 6.19259 11.4371 6.24774 11.4623 6.30844C11.4874 6.36913 11.5004 6.4342 11.5004 6.49991C11.5004 6.56561 11.4874 6.63068 11.4623 6.69138C11.4371 6.75207 11.4002 6.80722 11.3538 6.85366ZM10.2913 6.49991L8.5 4.70678V8.29303L10.2913 6.49991Z"
                                      fill="#858585"
                                    />
                                  </svg>
                                </Pagination.Next>
                              </Pagination>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </>
      )}
    </>
  );
};

export default Dashboard;
